import { gql } from '@apollo/client';

export const GENERATE_TIPALTI_IFRAME_URL = gql`
  mutation GenerateTipaltiIframeUrl($input: GenerateTipaltiIframeUrlInput!) {
    generateTipaltiIframeUrl(input: $input) {
      iframeUrl
    }
  }
`;